export default __webpack_public_path__ + "static/media/resetBackground.7d083e9e.jpg";